<template>
  <div
    v-if="priority"
    class="ticket-priority"
  >
    <span :class="priorities[priority].class">
      {{ priorities[priority].display }}
    </span>
    <small>
      {{ priorities[priority].sla }}
    </small>
  </div>
  <div
    v-else
    class="text-center"
  >
    -
  </div>
</template>

<script>
export default {
  props: {
    priority: {
      type: [String, null],
      required: true,
    },
    priorities: {
      type: Object,
      required: true,
    }
  },
}
</script>

<style lang="scss" scoped>
.ticket-priority {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;

  .danger {
    color: #d47777;
  }

  .warning {
    color: #ffc107;
  }

  .success {
    color: #6cc58c
  }

  .primary {
    color: #8260ac;
  }

  .secondary {
    color: #6c757d;
  }
}
</style>

